import { createReducer, on } from '@ngrx/store';
import * as setAddressValidate from '../actions/address-validate.actions';

export interface AddressValidate{
  data: any
}

export const initialState: AddressValidate = {
  data: {},
};

export const _addressValidate = createReducer(
  initialState,
  on(setAddressValidate.setAddressValidate, (state, {data}) => ({ ...state, data: data}) ),
);

export function addressValidate(state, action) {
  return _addressValidate(state, action);
}
